import { Injectable, inject } from '@angular/core';
import { DialogService } from '~core/services/dialog.service';
import { Observable, filter, tap } from 'rxjs';
import { ResourceFacade } from '~backoffice/app/~store/facades/resource.facade';
import { GlobalFacade } from '~backoffice/app/~store/facades/global.facade';
import { SnackbarService } from '~backoffice/app/~shared/services/snackbar.service';
import { DeleteConfirmComponent } from '~backoffice/app/~shared/components/modals/delete-confirm/delete-confirm.component';
import { LiveStream } from '~core/models/live-stream.models';
import { EditLiveStreamComponent } from '~backoffice/app/live-stream/modals/edit-live-stream/edit-live-stream.component';
import { LiveStreamService } from '~core/services/live-stream.service';

@Injectable()
export class LiveStreamManagementService {
  private resourceFacade = inject(ResourceFacade);
  private liveStreamService = inject(LiveStreamService);
  private globalFacade = inject(GlobalFacade);

  constructor(
    private snackBar: SnackbarService,
    private dialogService: DialogService
  ) {}

  edit(liveStream?: LiveStream): Observable<unknown> {
    this.globalFacade.setFormViolations([]);
    const dialogRef = this.dialogService.open({
      component: EditLiveStreamComponent,
      config: {
        panelClass: ['mat-dialog-custom-full-screen'],
        disableClose: true,
        height: '100vh',
        width: '100vw',
        maxWidth: '100vw'
      }
    });

    dialogRef.componentInstance.liveStream = liveStream;
    return dialogRef.afterClosed();
  }

  delete(liveStream: LiveStream): Observable<unknown> {
    const delete$ = this.liveStreamService.remove(liveStream.id);
    const dialogRef = this.dialogService.open({
      component: DeleteConfirmComponent,
      config: {
        panelClass: ['mat-dialog-custom'],
        disableClose: true
      }
    });

    dialogRef.componentRef!.setInput('removeObservable$', delete$);
    dialogRef.componentRef?.setInput(
      'title',
      'Voulez-vous supprimer ce liveStream ?'
    );

    return dialogRef.afterClosed().pipe(
      filter(Boolean),
      tap({
        next: () => {
          this.resourceFacade.getData({ refresh: true });
          this.snackBar.open({
            text: 'LiveStream supprimé avec succès',
            type: 'success'
          });
        }
      })
    );
  }

  toggleDefaultStatus(
    liveStream: LiveStream,
    oldState?: boolean
  ): Observable<LiveStream> {
    const newData = {
      markedAsDefault: oldState ? false : true
    };
    return this.liveStreamService.update(liveStream.id, newData).pipe(
      tap({
        next: () => {
          this.resourceFacade.getData({ refresh: true });
          this.snackBar.open({
            text: 'Statut du LiveStream mis à jour',
            type: 'success'
          });
        }
      })
    );
  }
}
